module.exports = __webpack_public_path__ + "static/media/icon-event__ii-guerra-mundial.b6dda253.svg";